import React from "react";
import { ZoomIn, ZoomOut, RotateCcw, Plus, Wand2 } from "lucide-react";

interface FlowToolbarProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  onSave?: () => void;
  isSaving?: boolean;
  canSave?: boolean;
  onAddNode?: () => void;
  className?: string;
  onAutoLayout?: () => void;
}

export default function FlowToolbar({
  onZoomIn,
  onZoomOut,
  onReset,
  onSave,
  isSaving = false,
  canSave = false,
  onAddNode,
  className,
  onAutoLayout,
}: FlowToolbarProps) {
  return (
    <div
      className={["flex items-center gap-2", className]
        .filter(Boolean)
        .join(" ")}
    >
      <button
        onClick={onZoomIn}
        className="px-3 py-1 bg-white border rounded flex items-center gap-1"
      >
        <ZoomIn className="h-4 w-4" /> Zoom in
      </button>
      <button
        onClick={onZoomOut}
        className="px-3 py-1 bg-white border rounded flex items-center gap-1"
      >
        <ZoomOut className="h-4 w-4" /> Zoom out
      </button>
      <button
        onClick={onReset}
        className="px-3 py-1 bg-white border rounded flex items-center gap-1"
      >
        <RotateCcw className="h-4 w-4" /> Reset
      </button>
      {onAutoLayout && (
        <button
          onClick={onAutoLayout}
          className="px-3 py-1 bg-white border rounded flex items-center gap-1"
          title="Reorder nodes to a simple layout"
        >
          <Wand2 className="h-4 w-4" /> Auto-layout
        </button>
      )}
      {onSave && (
        <button
          onClick={onSave}
          className="px-3 py-1 bg-blue-500 text-white rounded"
          title={canSave ? "Save positions" : "No changes to save"}
          disabled={isSaving || !canSave}
        >
          {isSaving ? "Saving…" : "Save positions"}
        </button>
      )}
      {onAddNode && (
        <button
          onClick={onAddNode}
          className="px-3 py-1 bg-green-600 text-white rounded flex items-center gap-1"
        >
          <Plus className="h-4 w-4" /> Add node
        </button>
      )}
      <span className="text-xs text-gray-500 ml-2">
        Alt+drag or middle-click to pan
      </span>
    </div>
  );
}
